export default __webpack_public_path__ + "static/media/Apple.2a7e56b2.png";